<template>
    <div class="project-groups check-selector">

        <div v-for="(group, index) in groups" :key="group.id" class="checkbox">
            <label :for="index">
                <div class="icon">
                    <i v-if="selectedGroups.includes(group.id)" class="fa fa-check-circle text-success"></i>
                    <i v-else class="fa fa-times-circle text-danger"></i>
                </div>
                <div class="insput">
                    <input type="checkbox" :readonly="readonly" :id="index" v-model="selectedGroups" :value="group.id" @change="updateInput()">
                </div>
                <div class="info">
                    <div class="name" v-text="group.name"></div>
                    <div class="code" v-text="group.code"></div>
                </div>
            </label>
        </div>

        <div v-if="groups.length == 0" class="alert alert-warning">
            <i class="fas fa-exclamation-circle"></i> Select the Energy Code Version in the Project Information tab.
        </div>
    </div>
</template>
<script>
    export default{

        props: {
            readonly: {
                required: false,
                type: Boolean,
                default: false,
            },
            value: {
                type: Array,
                required: true,
            },
            groups:{
                type: Array,
                required: true,
            }
        },

        data() {
            return {
                selectedGroups: this.value
            }
        },

        methods: {
            updateInput() {
                this.$emit('input', this.selectedGroups)
            }
        },

        watch:{
            value(){
                this.selectedGroups = this.value
            }
        }
    }
</script>
